/* eslint-disable camelcase */
import { useReducer } from 'react';

const answersInitialState = [];

const answersReducer = (state, action) => {
  const isTheSameQuestionId = ({ question_id }) => question_id === action.questionId;
  const isDifferentQuestionId = ({ question_id }) => question_id !== action.questionId;

  switch (action.type) {
    case 'set':
      return [
        ...state.filter(isDifferentQuestionId),
        {
          question_id: action.questionId,
          answers: [action.answer],
        },
      ];
    case 'push':
      return [
        ...state.filter(isDifferentQuestionId),
        state.find(isTheSameQuestionId)
          ? {
              ...state.find(isTheSameQuestionId),
              answers: [
                ...state.find(isTheSameQuestionId).answers,
                {
                  answer: action.answer,
                },
              ],
            }
          : {
              question_id: action.questionId,
              answers: [
                {
                  answer: action.answer,
                },
              ],
            },
      ];
    case 'remove':
      if (!state.find(isTheSameQuestionId)) {
        return state;
      }

      if (state.find(isTheSameQuestionId).answers.length <= 1) {
        return [...state.filter(isDifferentQuestionId)];
      }

      return [
        ...state.filter(isDifferentQuestionId),
        {
          ...state.find(isTheSameQuestionId),
          answers: [
            ...state.find(isTheSameQuestionId).answers.filter(value => value !== action.answer),
          ],
        },
      ];
    case 'removeAnswers':
      if (!state.find(isTheSameQuestionId)) {
        return state;
      }

      return [...state.filter(isDifferentQuestionId)];
    default:
      return state;
  }
};

const paramsInitialState = {
  isHeaderVisible: true,
};

const paramsReducer = (state, action) => {
  switch (action.type) {
    case 'set':
      return {
        ...state,
        [action.name]: action.value,
      };
    default:
      return state;
  }
};

export const useQuestionnaire = () => {
  const [answers, answersDispatch] = useReducer(answersReducer, answersInitialState);
  const [params, paramsDispatch] = useReducer(paramsReducer, paramsInitialState);
  const setAnswer = (questionId, answer) => answersDispatch({ type: 'set', questionId, answer });
  const pushAnswer = (questionId, answer) => answersDispatch({ type: 'push', questionId, answer });
  const removeAnswer = (questionId, answer) =>
    answersDispatch({ type: 'remove', questionId, answer });
  const removeAnswers = questionId => answersDispatch({ type: 'removeAnswers', questionId });
  const setParam = (name, value) => paramsDispatch({ type: 'set', name, value });
  return { setAnswer, removeAnswer, removeAnswers, setParam, pushAnswer, answers, params };
};
